import { ComparisonOperators } from '../enums/comparison-operators.enum';

export class JsonDataSearch {
	property: string;
	operator: ComparisonOperators;
	dataType: string;
	value: any;
	recordVariable?: boolean;

	constructor(init: Partial<JsonDataSearch>) {
		if (!init.property) {
			throw new Error('The property is a required property.');
		}
		if (!init.operator) {
			throw new Error('The operator is a required property.');
		}

		if (!init.dataType) {
			throw new Error('The dataType is a required property.');
		}
		Object.assign(this, init);
		this.property = init.property;
		this.operator = init.operator;
		this.dataType = init.dataType;
	}
}
